import { ThemeConfig } from 'src/context/ThemeContext';

export interface TEFComponentConfig {
  colors: ThemeConfig['colors'];
  typography: ThemeConfig['typography'];
  spacing: ThemeConfig['spacing'];
  borderRadius: ThemeConfig['borderRadius'];
  form: ThemeConfig['form'];
}

export const createComponentConfig = (theme: ThemeConfig): TEFComponentConfig => {
  return {
    colors: theme.colors,
    typography: theme.typography,
    spacing: theme.spacing,
    borderRadius: theme.borderRadius,
    form: theme.form,
  };
};
